import React, { useEffect, useState } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import axios from '../../api/AxiosConfig';
// import AuthContext if you have one
// import { AuthContext } from '../../context/AuthContext';

const BlogPostPage = () => {
  const { slug } = useParams();
  const navigate = useNavigate();

  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  // Example: get current user
  // const { user } = useContext(AuthContext);
  const user = { isAdmin: true }; // temporary placeholder

  useEffect(() => {
    const fetchPost = async () => {
      try {
        const res = await axios.get(`/blog/${slug}`);
        setPost(res.data.data);
      } catch (err) {
        console.error('Error fetching blog post:', err);
        setError('Post not found.');
      } finally {
        setLoading(false);
      }
    };

    fetchPost();
  }, [slug]);


  const handleEdit = () => {
    navigate(`/blog`); // adjust based on your route
  };

  if (loading) return <div className="text-center py-10">Loading...</div>;
  if (error) return <div className="text-center text-red-600 py-10">{error}</div>;
  if (!post) return <div className="text-center py-10">No post found.</div>;

  return (
    <section className="py-16 bg-gray-50 min-h-screen">
      <div className="container mx-auto px-4 max-w-4xl">
        <Link to="/blog" className="text-blue-600 hover:text-blue-800 mb-6 inline-block">
          &larr; Back to all posts
        </Link>

        <article className="bg-white rounded-lg shadow-md p-8">
          <h1 className="text-3xl font-bold mb-4">{post.title}</h1>
          <p className="text-gray-500 mb-6">
            {post.readTime}
            {post.createdAt && !isNaN(Date.parse(post.createdAt)) && (
              <> • {new Date(post.createdAt).toLocaleDateString()}</>
            )}
          </p>

          <div 
            className="prose prose-lg max-w-none"
            dangerouslySetInnerHTML={{ __html: post.content }}
          />

          {user?.isAdmin && (
            <div className="flex gap-4 mt-8">
              <button
                onClick={handleEdit}
                className="bg-yellow-500 text-white px-4 py-2 rounded hover:bg-yellow-600"
              >
                Go to blog
              </button>
              
            </div>
          )}
        </article>
      </div>
    </section>
  );
};

export default BlogPostPage;
